<template>
  <div id="list-informations" class="list-informations" :class="{ 'segment-infos': isSegmentMode }">
    <div style="width: 250px;" v-if="isSegmentMode && Object.keys(segment).length !== 0">
      <div v-show="showpop" class="info-pop cnqr-popover"  style="white-space: nowrap;" v-on:click="showpop = false">
        <b-row class="content text-m">
          {{ $t('panels.infos.name_segment') }}
          {{ segment.title }}
        </b-row>

        <b-row class="content  text-m content__duration">
          {{ $t('panels.infos.duration_total') }}
          {{ totalDurationScreens | FormatTime }}
        </b-row>
      </div>

      <div class="btn-info-c" v-on:click="showpop = !showpop">
        <span class="mr-2 fa fa-info-circle"></span>{{ $t('panels.infos.title') }}
      </div>
    </div>

    <div v-if="!isSegmentMode && Object.keys(template).length !== 0">
      <div
        v-show="showpop"
        class="info-pop cnqr-popover arrow top info-pop-3"
        v-on:click="showpop = false"
        style="white-space: nowrap;"
      >
        <b-row class=" text-m content">
          {{ $t('panels.infos.name_template') }}
          {{ template.title }}
        </b-row>
        <b-row
          class="content text-m content__duration"
          v-has-permission="'initialize_duration_template_action'"
        >
          {{ $t('panels.infos.duration_template') }}
          <span v-if="isEditMode"> {{ Getduration(template.duration) }}</span>
          <span v-else> {{ template.duration }}</span>
        </b-row>

        <!-- todo -2 --->
        <b-row class="content content__duration text-m " v-if="paramsClient.default_segment_duration !== null">
          {{ $t('panels.infos.duration_total') }}
          {{ (totalDurationSegments - 2) | FormatTime }}
        </b-row>
        <b-row class="content content__duration text-m " v-else>
          {{ $t('panels.infos.duration_total') }}
          {{ (totalDurationSegments) | FormatTime }}
        </b-row>
        <b-row class="content content__duration text-m">
          {{ $t('panels.infos.size_template') }} {{ canvasSize.width }} x {{ canvasSize.height }}
        </b-row>
      </div>

      <div class="btn-info-c" v-on:click="showpop = !showpop">
        <span class="mr-2 fa fa-info-circle"></span>{{ $t('panels.infos.title') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import HasPermission from '../core/directives/HasPermission.js';

export default {
  name: 'Informations',
  directives: {
    HasPermission,
  },
  data() {
    return {
      placement: 'top',
      showpop: false,
    };
  },
  methods: {
    Getduration(value) {
      if (value != null) {
        let hours = Math.floor(value / 3600);
        value %= 3600;
        let minutes = Math.floor(value / 60);
        let seconds = value % 60;
        let addZero = v => (v < 10 ? '0' + v : v);
        let t = [];
        t.push(addZero(hours));
        t.push(addZero(minutes));
        t.push(addZero(seconds));
        let time = t[0] + ':' + t[1] + ':' + t[2];
        return time;
      }
    },
    /*
    onclose() {
      var btninfo = document.querySelector('.btn-info-c');
      document.addEventListener('click', function(event) {
        var isClickInsidebtninfo = btninfo.contains(event.target);
        if (isClickInsidebtninfo ) {
        } else {
            this.showpop=false
        }
      });
    }

    */
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      segment: 'segments/getCurrent',
      template: 'slides/getTemplate',
      totalDurationSegments: 'segments/getAllSegmentsDuration',
      totalDurationScreens: 'slides/getAllScreensDuration',
      canvasSize: 'common/getCanvasSize',
      paramsClient: 'getParamsClients',
    }),
    isSegmentMode() {
      return this.$route.name === 'segment';
    },
    isEditMode() {
      return this.$route.name === 'edit';
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/variables';
  @import '../scss/media-queries';

  .list-informations.rotate {
  bottom: 20px;
}
.text-m {
  margin-right: 15px !important;
  margin-left: 15px !important;
  margin-top: 10px;
  margin-bottom: 10px;
}
.btn-info-c {
  cursor: pointer;
  background-color: #ffffff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-size: 14px;
  margin-right: 50px;
  margin-left: 50px;
  padding-left: 25px;
  padding-right: 25px;
}

.info-pop {
  margin-right: 15px;
  margin-left: 15px;
  padding-left: 30px;
  padding-right: 30px;
  background-color: white;
  position: absolute;
  bottom: 25px;
  width: 100%;
  height: auto;
  margin: 10px;
  font-size: 12px;
  left: -1em;
}

.info-pop:before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  left: 50%;
  bottom: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-right: 1px solid #869098;
  border-bottom: 1px solid #869098;
  transform: rotate(45deg);
}
.cnqr-popover {
  z-index: 110;
  max-width: 276px;
  padding: 1px;
  text-align: left;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #869098;
  //border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  -webkit-box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  white-space: normal;
}
.list-informations {
  display: block;
  position: absolute;
  bottom: $height-custom-panel;
  z-index: 7;
  right: 240px;
  text-align: left;
  color: #6f7982 !important;
  font-size: 10px;
  font-family: sans-serif;

  @include tablet {
    right: $width-block + 10;
  }
}
/*
.list-informations {
  position: absolute;
  width: 230px;
  height: 122px;
  bottom: 0;
  padding: 2px 4px;
  right: 0;
  z-index: 1;
  text-align: left;
  background-color: #fff;
  &.segment-infos {
    padding: 16px 4px;
  }
  &__fieldset {
    display: block;
    margin-inline-start: 2px !important;
    margin-inline-end: 2px !important;
    padding-block-start: 0.35em !important;
    padding-inline-start: 0.75em !important;
    padding-inline-end: 0.75em !important;
    padding-block-end: 0.625em !important;
    min-inline-size: min-content !important;
    border-width: 2px !important;
    border-style: groove !important;
    border-image: initial !important;
    font-size: 0.7em !important;
    color: #939ea7 !important;
    font-family: sans-serif;
    border-color: #fefeff !important;
    border-radius: 5px;
    legend {
      display: block !important;
      padding-inline-start: 2px !important;
      padding-inline-end: 2px !important;
      border-width: initial !important;
      border-style: none !important;
      border-color: initial !important;
      border-image: initial !important;
      max-width: 150px !important;
      margin-bottom: 0 !important;
      font-size: 1rem !important;
      line-height: inherit !important;
      color: inherit !important;
      white-space: normal !important;
      padding: 0 1em !important;
      span {
        margin: 5px;
      }
    }
    .content {
      margin: 0 !important;
      font-size: 12px;
      padding: 3px 0;
    }
  }
}

  */
</style>



// WEBPACK FOOTER //
// Informations.vue?0ab68130